import React from "react";
import {Grid} from "@mui/material";
import {BaseInput} from "../../../../designSystem/components/BaseInput";

export const BloodOxygenForm = ({
  measurement,
  onChangeMeasurement,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <BaseInput
        type="number"
        onChange={e => onChangeMeasurement({...measurement, bloodOxygen: e.target.value})}
        value={measurement.bloodOxygen}
        placeholder="血氧(%)"
      />
    </Grid>
  </Grid>
)